






















































































































































import { Vue, Component, Prop, Inject, Watch } from 'vue-property-decorator'
// import { GetterProduct, ProductItem } from '@/store/product'
// import { ProductItem } from '@/store/product'
import { GetterCart, MutationCart } from '@/store/cart'
import ProductModel from '@/api/model/product'
import ProductResource from '@/api/resources/product'
import TitleText from '@/components/system/TitleText.vue'
import find from 'lodash/find'

@Component({ components: { TitleText } })
export default class ListProduct extends Vue {
  @Prop()
  titreList: string

  @Prop()
  idList: number

  // @GetterProduct
  // productAll: ProductItem[]

  @GetterCart
  selectedItems: ProductModel[]
  // selectedItems: { (selectedItems: ProductItem[]): void }

  @MutationCart
  setItemsArray: { (items: ProductModel[]): void }

  @Inject()
  productResource: ProductResource

  // @Watch('isActive', { immediate: true })
  // async onIsActiveChange (data: boolean) {
  //   console.log('isActive' + this.isActive + '::fin')
  //   if (data) this.panel = 0
  // }

  panel: number = 0
  products: ProductModel[] = []

  isActive: boolean = false

  async mounted () {
    if (this.idList === 0) {
      this.products = await this.productResource.productsStock()
    } else {
      this.products = await this.productResource.productsTag(this.idList)
    }
  }

  add (product: ProductModel) {
    let arrayData: ProductModel[] = []
    if (this.selectedItems && this.selectedItems.length > 0) {
      arrayData = this.selectedItems
    }
    if (product) {
      let itemExist = find(arrayData, (o) => o.name === product.name)
      console.log('Si existe')
      console.log(itemExist)
      if (itemExist) {
        itemExist.quantite = product.quantite
      } else {
        arrayData.push(product)
      }
      this.setItemsArray(arrayData)
      product.buy = false
    }
  }
}
